import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import {
  GenerateProductSeoTagsBrandRequestDto,
  GenerateProductSeoTagsBrandResponseDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { generateProductSeoTagsBrand } from '../../../productsSlice';

function useGenerateProductSeoTagsBrand() {
  const dispatch = useAppDispatch();

  const generateSeoTagsBrand = useCallback(
    async (
      requestDto: GenerateProductSeoTagsBrandRequestDto,
    ): Promise<GenerateProductSeoTagsBrandResponseDto> => {
      const result = await dispatch(generateProductSeoTagsBrand(requestDto));
      return unwrapResult(result);
    },
    [dispatch],
  );

  return { generateSeoTagsBrand };
}

export default useGenerateProductSeoTagsBrand;
